
export default function GoldenGuaranteeSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-amber-50 via-white to-amber-50">
      <div className="container mx-auto px-4 max-w-7xl">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full mb-6 shadow-lg">
            <i className="ri-medal-fill text-4xl text-white"></i>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            الضمان الذهبي 🥇
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-amber-600 mx-auto rounded-full"></div>
        </div>

        {/* About Company */}
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 mb-12">
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed text-center mb-8">
            تُعدّ <strong className="text-amber-600">فخامة الرفاهية للتوصيل</strong> للنقل البري من افضل وسائل التوصيل الرائدة في مجال نقل الحجاج والمعتمرين من وإلى مطار جدة الدولي.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
            <div className="flex items-start gap-4 bg-amber-50 rounded-2xl p-6">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-500 rounded-full flex-shrink-0">
                <i className="ri-vip-crown-fill text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 text-lg mb-2">رحلات VIP منتظمة</h3>
                <p className="text-gray-700">من مطار جدة الدولي إلى مكة المكرمة على مدار 24 ساعة</p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-amber-50 rounded-2xl p-6">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-500 rounded-full flex-shrink-0">
                <i className="ri-group-fill text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 text-lg mb-2">خدمة النقل</h3>
                <p className="text-gray-700">خدمة النقل الفردي والجماعي</p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-amber-50 rounded-2xl p-6">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-500 rounded-full flex-shrink-0">
                <i className="ri-plane-fill text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 text-lg mb-2">توصيل المطارات</h3>
                <p className="text-gray-700">توصيل من وإلى المطارات</p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-amber-50 rounded-2xl p-6">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-500 rounded-full flex-shrink-0">
                <i className="ri-map-pin-fill text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 text-lg mb-2">التوصيل بين المدن</h3>
                <p className="text-gray-700">جدة - مكة - المدينة المنورة - الطائف</p>
              </div>
            </div>
          </div>
        </div>

        {/* Golden Guarantee Card */}
        <div className="bg-gradient-to-br from-gold via-gold-dark to-gold-dark rounded-3xl shadow-2xl p-8 md:p-12 text-white relative overflow-hidden">
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-32 translate-x-32"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full translate-y-24 -translate-x-24"></div>
          
          <div className="relative z-10">
            <div className="flex items-center justify-center gap-3 mb-6">
              <i className="ri-shield-star-fill text-5xl"></i>
              <h3 className="text-3xl md:text-4xl font-bold">لرضا العملاء</h3>
            </div>

            <p className="text-lg md:text-xl leading-relaxed mb-8 text-center max-w-4xl mx-auto">
              نحن في <strong>[فخامة الرفاهية للتوصيل]</strong> نضع رضاكم هدفنا الأول. إذا حدث أي تقصير من جانب الكابتن أو لم تكن راضيًا عن الخدمة المقدمة، نضمن لكم:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-6 border-2 border-white/30">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full flex-shrink-0">
                    <i className="ri-money-dollar-circle-fill text-2xl text-amber-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-xl mb-2">استرداد كامل المبلغ</h4>
                    <p className="text-white/90">استرداد كامل المبلغ المدفوع فورًا</p>
                  </div>
                </div>
              </div>

              <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-6 border-2 border-white/30">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full flex-shrink-0">
                    <i className="ri-gift-fill text-2xl text-amber-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-xl mb-2">توصيل مجاني</h4>
                    <p className="text-white/90">توصيل مجاني لأي خدمة تم تقديمها</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center">
              <p className="text-2xl font-bold">رضاكم يهمنا ❤️</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
